import { useAuthStore } from '../stores';
import { refreshAccessToken } from './tokenRefresh';
export async function authFetch(input, init = {}) {
    const { skipAuth, ...fetchInit } = init;
    const withAuth = (token) => {
        const headers = new Headers(fetchInit.headers);
        if (!skipAuth && token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return { ...fetchInit, headers };
    };
    const token = skipAuth ? null : useAuthStore.getState().accessToken;
    let response = await fetch(input, withAuth(token));
    if (!skipAuth && response.status === 401 && useAuthStore.getState().refreshToken) {
        const newToken = await refreshAccessToken();
        if (newToken) {
            response = await fetch(input, withAuth(newToken));
        }
    }
    return response;
}
